module.exports = __webpack_public_path__ + "img/section2_img.f9029b79.png";